import { Link } from "react-router-dom";
import { games } from "@/mocks/games";
import { reviews } from "@/mocks/reviews";

const categoryName: Record<string, string> = {
  campus: "校园纯爱", fantasy: "奇幻冒险", city: "都市职场", thriller: "悬疑惊悚",
  harem: "后宫多线", healing: "治愈日常", dark: "暗黑题材", world: "架空世界观",
};

export default function ReviewList() {
  const latest = [...games].sort((a, b) => b.year - a.year).slice(0, 4);

  return (
    <section id="reviews" className="bg-background-100/70">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-20">
        <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-xs font-medium uppercase tracking-[0.2em] text-accent-600">Latest</p>
            <h2 className="mt-2 font-display text-2xl font-bold text-foreground-950 md:text-3xl">
              最新评测
            </h2>
          </div>
          <p className="max-w-md text-sm text-foreground-600">
            每一篇评测都来自编辑实机体验，从剧情、美术、演出到耐玩度逐项打分。
          </p>
        </div>

        <div className="mt-8 grid gap-6 md:grid-cols-2">
          {latest.map((g) => {
            const rv = reviews[g.id];
            return (
              <Link
                key={g.id}
                to={`/review/${g.id}`}
                className="group flex flex-col gap-5 rounded-2xl border border-background-200/70 bg-background-50 p-5 transition-all hover:-translate-y-1 hover:border-primary-300 sm:flex-row"
              >
                <img
                  src={g.cover}
                  alt={`${g.title} 评测封面`}
                  className="h-40 w-full shrink-0 rounded-xl object-cover object-top sm:h-44 sm:w-32"
                />
                <div className="flex min-w-0 flex-1 flex-col">
                  <div className="flex items-center gap-2">
                    <h3 className="truncate font-display text-lg font-bold text-foreground-950 group-hover:text-accent-700">
                      {g.title}
                    </h3>
                    <span className="rounded-full bg-background-200 px-2 py-0.5 text-xs text-foreground-500">
                      {categoryName[g.category]}
                    </span>
                  </div>
                  <p className="mt-2 line-clamp-3 text-sm leading-relaxed text-foreground-600">
                    {rv ? rv.lead : g.blurb}
                  </p>
                  <div className="mt-auto flex items-center justify-between pt-4">
                    <div className="flex items-center gap-1.5 text-xs text-foreground-500">
                      <i className="ri-calendar-line"></i>
                      {g.year} 年
                      <span className="text-foreground-300">·</span>
                      {g.platform}
                    </div>
                    <span className="font-display text-lg font-black text-primary-600">{g.score.toFixed(1)}</span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}